import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { getName } from "../../ModelMixins/CatalogMemberMixin";
import Styles from "./feature-info-catalog-item.scss";
import FeatureInfoSection from "./FeatureInfoSection";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default observer(props => {
  var _catalogItem$maximumS;
  const {
    t
  } = useTranslation();
  const features = props.features;
  const catalogItem = props.catalogItem;
  const terria = props.viewState.terria;
  const maximumShownFeatureInfos = (_catalogItem$maximumS = catalogItem.maximumShownFeatureInfos) !== null && _catalogItem$maximumS !== void 0 ? _catalogItem$maximumS : terria.configParameters.defaultMaximumShownFeatureInfos;
  const hiddenNumber = features.length - maximumShownFeatureInfos; // A positive hiddenNumber => some are hidden; negative means none are.

  return /*#__PURE__*/_jsx("li", {
    children: /*#__PURE__*/_jsxs("ul", {
      className: Styles.sections,
      children: [hiddenNumber === 1 ? /*#__PURE__*/_jsxs("li", {
        className: Styles.messageItem,
        children: [/*#__PURE__*/_jsx("strong", {
          children: t("featureInfo.catalogItem.moreThanMax", {
            maximum: maximumShownFeatureInfos,
            catalogItemName: getName(catalogItem)
          })
        }), /*#__PURE__*/_jsx("br", {}), t("featureInfo.catalogItem.featureInfoShown", {
          maximum: maximumShownFeatureInfos
        })]
      }) : null, hiddenNumber > 1 ? /*#__PURE__*/_jsxs("li", {
        className: Styles.messageItem,
        children: [/*#__PURE__*/_jsx("strong", {
          children: t("featureInfo.catalogItem.featuresFound", {
            featCount: features.length,
            catalogItemName: getName(catalogItem)
          })
        }), /*#__PURE__*/_jsx("br", {}), t("featureInfo.catalogItem.featureInfoShown", {
          maximum: maximumShownFeatureInfos
        })]
      }) : null, features.slice(0, maximumShownFeatureInfos).map((feature, i) => {
        var _terria$pickedFeature;
        return /*#__PURE__*/_jsx(FeatureInfoSection, {
          catalogItem: catalogItem,
          feature: feature,
          position: (_terria$pickedFeature = terria.pickedFeatures) === null || _terria$pickedFeature === void 0 ? void 0 : _terria$pickedFeature.pickPosition,
          isOpen: !!(feature === terria.selectedFeature || props.printView),
          onClickHeader: props.onToggleOpen,
          printView: props.printView
        }, i);
      })]
    })
  });
});